export const ACCOUNT_TYPES = ['EASY', 'NOTICE', 'TERM'];
export const SAVINGS_TYPES = ['LUMP', 'REG'];
export const PARAMS = ['accounttype', 'amount', 'bankratingisimportant', 'childsaver', 'instantaccess', 'notice', 'savingstype', 'term'];
export const TERMS = [3, 6, 12, 24, 36, 48, 60, 120];
